import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  checkboxCell: {
    width: 18,
    paddingRight: "0 !important",
  },
}));
